<template>
  <transition name="showHeader">
    <div class="header-animat">
        <a-layout-header style="padding:0;position:relative;background-color: #FFFFFF" >
            <div class="header clearfix" :style="{  position: 'relative', width:'100%'}">
<!--            <div class="header clearfix" :style="{  position: 'fixed', width:'calc(100% - ' + [collapsed ? 140 : 240] + 'px)'}">-->
          <div style="float:left;">
          <a-icon class="trigger middle left" :type="collapsed ? 'menu-unfold' : 'menu-fold'" @click="toggle"/>
          <span class="font20 title left">一体化政务平台</span>
<!--              <span style="margin-right:5px; font-weight:bold;cursor:pointer" class="font14 left" @click="goWeb">回到网站</span>-->
<!--              <span class="ecp-icon ecp-icon-fanhui left" style="margin-right:214px;cursor:pointer" @click="goWeb"></span>-->
<!--                  <a-input v-model="keyWord" class="search-input left" v-on:keyup.enter="onSearch" placeholder="请输入搜索内容"-->
<!--                           style="margin-top:17px">-->
<!--                    <span slot="prefix" class="ecp-icon ecp-icon-sousuo font16 top" @click="onSearch"-->
<!--                          style="color:#888888"></span>-->
<!--                  </a-input>-->
<!--                  <img src="../../assets/home/glass.png" alt="" style="width:24px;height:24px;margin-top:19px"-->
<!--                       class="center left">-->
          </div>
          <div class="user-wrapper">
            <div class="content-box">
              <a-popover
                  placement="bottomRight"
                  :autoAdjustOverflow="true"
                  :arrowPointAtCenter="true"
                  class="action" @click="toSys()">
                  <template slot="content">
                    <a-list class="demo-loadmore-list" :loading="loading" itemLayout="horizontal" :dataSource="data" size="middle" >
                      <div
                        v-if="showLoadingMore"
                        slot="loadMore"
                        :style="{ textAlign: 'center', marginTop: '12px', height: '32px', lineHeight: '32px' }"
                      >
                        <a-spin v-if="loadingMore" />
                        <a-button class="btn" v-else @click="toSys">查看更多</a-button>
                      </div>
                      <a-list-item slot="renderItem" slot-scope="item, index" >
                        <a-list-item-meta :description="item.syscreatedate">
                          <a slot="title" @click="viewMsg(item.msg_uuid)">{{item.content}}</a>
                        </a-list-item-meta>
                      </a-list-item>
                      <div slot="header" style="margin-right: 20px">
                        <span>系统消息</span>
                        <span style="float: right;margin-left: 10px">
                        <a @click="setAllReaded()" v-show="showLoadingMore">全部已读</a></span></div>
                    </a-list>
                  </template>
                  <a-badge :count="totalCount" :offset="[-2]" class="notice-badge">
                  </a-badge>
                  <span class="ecp-icon ecp-icon-xiaoxi1 top  font888" style="color:#ffffff; font-size:26px"></span>
                </a-popover>
              <a-dropdown class="action ant-dropdown-link user-dropdown-menu" placement="bottomCenter">
                <span class="action ant-dropdown-link user-dropdown-menu">
                  <a-icon type="setting" class="font20 middle  font888"/>
                </span>
                <a-menu slot="overlay" >
                  <a-menu-item  @click="goUserDesgin">
                    <span>首页自定义</span>
                  </a-menu-item>
                  <!--<a-menu-item  @click="goShowDesgin">
                    <span>自定义效果展示</span>
                  </a-menu-item>-->
                  <a-menu-item  @click="restoreDefault">
                    <span>恢复默认模板</span>
                  </a-menu-item>
                </a-menu>
              </a-dropdown>
                <a-dropdown class="action ant-dropdown-link user-dropdown-menu" >
                <span class="action ant-dropdown-link user-dropdown-menu">
                  <span class="ecp-icon ecp-icon-tongxunlu font24 top "></span>
                </span>
                <a-menu slot="overlay">
                  <a-menu-item key=""  @click="help">
                    <span>帮助</span>
                  </a-menu-item>
                </a-menu>
              </a-dropdown>
             <!-- <a-dropdown class="action ant-dropdown-link user-dropdown-menu">
                <span class="action ant-dropdown-link user-dropdown-menu">
                  <span class="ecp-icon ecp-icon-youxiang font24 top"></span>
                </span>
                <a-menu slot="overlay">
                  <a-menu-item key="">
                    <span>邮箱</span>
                  </a-menu-item>
                </a-menu>
              </a-dropdown>&ndash;&gt;-->
              <a-dropdown class="action ant-dropdown-link user-dropdown-menu">
                <span class="action ant-dropdown-link user-dropdown-menu">
                  <div class="avatar-bg"></div>
                  <span class="ecp-icon ecp-icon-yonghuguanli font24 top avatar-content "></span>
                  <!-- <span >{{userName}}</span> -->
                </span>
                <a-menu slot="overlay">
                  <a-sub-menu :title="userName" icon="user">
                    <a-menu-item @click="modInfor">个人信息设置</a-menu-item>
                    <a-menu-item @click="wfDepute">个人委托设置</a-menu-item>
                  </a-sub-menu>
                  <a-menu-divider v-if="departs.length>0"></a-menu-divider>
                  <a-menu-item v-for="item in departs" :key="item.id" @click="changeDepart">
                    <a-icon type="team"/>
                    <span>{{item.name}}</span>
                  </a-menu-item>
                  <a-menu-divider v-if="departs.length>0"></a-menu-divider>
                  <a-menu-item @click="logout">
                    <a-icon type="logout"/>
                    <span>退出登录</span>
                  </a-menu-item>
                </a-menu>
              </a-dropdown>

            </div>
          </div>
        </div>
      </a-layout-header>
      <a-modal
        title="用户基本信息"
        :width="1400"
        :visible="visible"
        :confirmLoading="confirmLoading"
        @ok="handleOk"
        @cancel="handleCancel">
        <a-form :selfUpdate="true" :form="form">
          <a-divider orientation="left">用户基本信息</a-divider>
          <a-spin :spinning="confirmLoading">
            <a-row :gutter="16">
              <a-col :span="12">
                <a-form-item label="姓名" :labelCol="{span:7}" :wrapperCol="{span:17}">
                  <a-input v-decorator="['person_name']" disabled="true"/>
                </a-form-item>
                <a-form-item label="性别" :labelCol="{span:7}" :wrapperCol="{span:17}">
                  <a-select
                    v-decorator="['gender_scode',{rules: [{ required: true, message: '请选择性别!'}]}]"
                    placeholder="请选择性别!">
                    <a-select-option value="1">男</a-select-option>
                    <a-select-option value="2">女</a-select-option>
                  </a-select>
                </a-form-item>
                <a-form-item label="证件类型" :labelCol="{span:7}" :wrapperCol="{span:17}">
                  <!--            <a-input v-decorator="['cer_type_scode',{rules: [{required: true}]}]"/>-->
                  <ecp-select v-decorator="['cer_type_scode',{rules: [{required: true, message: '请选择证件类型!'}]}]"
                              ecp-dict-type="UC_CER_TYPE"></ecp-select>
                </a-form-item>
                <a-form-item label="国家" :labelCol="{span:7}" :wrapperCol="{span:17}">
                  <a-input v-decorator="['country',{rules: [{required: false}]}]"/>
                </a-form-item>
                <a-form-item label="政治面貌" :labelCol="{span:7}" :wrapperCol="{span:17}">
                  <!--            <a-input v-decorator="['politics_uuid',{rules: [{required: false}]}]"/>-->
                  <ecp-select v-decorator="['politics_uuid',{rules: [{required: false}]}]"
                              ecp-dict-type="ENUM_UC_POLITICS"></ecp-select>
                </a-form-item>
                <a-form-item label="民族" :labelCol="{span:7}" :wrapperCol="{span:17}">
                  <!--            <a-input v-decorator="['nation',{rules: [{required: false}]}]"/>-->
                  <ecp-select v-decorator="['nation',{rules: [{required: false}]}]"
                              ecp-dict-type="ENUM_UC_NATION"></ecp-select>
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item label="曾用名" :labelCol="{span:7}" :wrapperCol="{span:17}">
                  <a-input v-decorator="['old_name',{rules: [{required: false}]}]"/>
                </a-form-item>
                <a-form-item label="出生日期" :labelCol="{span:7}" :wrapperCol="{span:17}">
                  <a-date-picker v-decorator="['birth_date',{rules: [{required: true, message: '请选择出生日期!'}]}]"
                                 style="width:367px"/>
                  <!--                  <ecp-datebox  v-decorator="['birth_date',{rules: [{required: true, message: '请选择出生日期!'}]}]" style="width:367px"></ecp-datebox>-->
                </a-form-item>
                <a-form-item label="证件号码" :labelCol="{span:7}" :wrapperCol="{span:17}">
                  <a-input v-decorator="['id_no',{rules: [{required: true, message: '请输入证件号码!'}]}]"/>
                </a-form-item>
                <a-form-item label="籍贯" :labelCol="{span:7}" :wrapperCol="{span:17}">
                  <a-input v-decorator="['nation_place',{rules: [{required: false}]}]"/>
                </a-form-item>
                <a-form-item label="学历" :labelCol="{span:7}" :wrapperCol="{span:17}">
                  <!--            <a-input v-decorator="['diploma_uuid',{rules: [{required: false}]}]"/>-->
                  <ecp-select v-decorator="['diploma_uuid',{rules: [{required: false}]}]"
                              ecp-dict-type="ENUM_UC_DIPLOMA"></ecp-select>
                </a-form-item>
                <a-form-item label="钉钉" :labelCol="{span:7}" :wrapperCol="{span:17}">
                  <a-input v-decorator="['dd_no']"></a-input>
                </a-form-item>
              </a-col>
            </a-row>
            <a-form-item label="常住地址" :labelCol="{span:3}" :wrapperCol="{span:21}">
              <a-input v-decorator="['address',{rules: [{required: false}]}]"/>
            </a-form-item>
            <a-row :gutter="16">
              <a-col span="12">
                <a-form-item label="内部邮箱" :labelCol="{span:7}" :wrapperCol="{span:17}">
                  <!--                  人员状态-->
                  <a-input v-decorator="['person_status_uuid']" type="hidden"/>
                  <!--                  人员编号-->
                  <a-input v-decorator="['person_code']" type="hidden"/>
                  <!--                  人员部门-->
                  <a-input v-decorator="['depart_uuid']" type="hidden"/>
                  <a-input v-decorator="['backup_email']" disabled="true"></a-input>
                </a-form-item>
                <a-form-item label="手机号码" :labelCol="{span:7}" :wrapperCol="{span:17}">
                  <a-input v-decorator="['master_mobile']"></a-input>
                </a-form-item>
                <a-form-item label="虚拟网短号" :labelCol="{span:7}" :wrapperCol="{span:17}">
                  <a-input v-decorator="['backup_mobile']"></a-input>
                </a-form-item>

              </a-col>
              <a-col :span="12">
                <a-form-item label="外部邮箱" :labelCol="{span:7}" :wrapperCol="{span:17}">
                  <a-input v-decorator="['master_email',{rules: [{required: false}]}]"/>
                </a-form-item>
                <a-form-item label="办公室电话" :labelCol="{span:7}" :wrapperCol="{span:17}">
                  <a-input v-decorator="['office_phone_no',{rules: [{required: false}]}]"/>
                </a-form-item>
                <a-form-item label="QQ号码" :labelCol="{span:7}" :wrapperCol="{span:17}">
                  <a-input v-decorator="['qq_no',{rules: [{required: false}]}]"/>
                </a-form-item>
              </a-col>
            </a-row>
            <!--            <a-form-item label="头像" :labelCol="{span:3}" :wrapperCol="{span:21}">-->
            <!--              <a-upload class="upload-list-inline"-->
            <!--                        listType="picture"-->
            <!--                        v-decorator="['head_image']"-->
            <!--                        :defaultFileList="fileList"-->
            <!--                        action="https://www.mocky.io/v2/5cc8019d300000980a055e76">-->
            <!--                <a-button> <a-icon type="upload" /> upload </a-button>-->
            <!--              </a-upload>-->
            <!--            </a-form-item>-->
          </a-spin>
        </a-form>
      </a-modal>
      <a-modal
        title="密码修改"
        :width="640"
        :visible="visible_pwd"
        :confirmLoading="confirmLoading"
        @ok="handleok_pwd"
        @cancel="handleCancel">
        <a-form :selfUpdate="true" :form="form_pwd">
          <div>
            您当前密码复杂度较低，不符合密码复杂度要求，新密码需符合以下密码策略：<br/>
            <span style="color: red">{{passwordDesc}}</span>
            <a-form-item
              label="旧密码"
              :labelCol="{span:7}"
              :wrapperCol="{span:13}">
              <a-input-password placeholder="请输入当前密码"
                                v-decorator="['old_pwd', {rules: [{required: true, message: '请输入当前密码!'}]}]"/>
              <a-input hidden v-model="account_uuid"/>
            </a-form-item>
            <a-form-item
              label="新密码"
              :labelCol="{span:7}"
              :wrapperCol="{span:13}">
              <a-input-password placeholder="请输入新密码"
                                v-decorator="['login_pwd', {rules: [{required: true, message: '请输入新密码!'}]}]"/>
            </a-form-item>
          </div>
        </a-form>
      </a-modal>
      <a-modal
        title="消息详情"
        :width="800"
        :visible="visible_modal"
        :confirmLoading="confirmLoading"
        @cancel="handleCancel">
        <a-spin :spinning="confirmLoading">
          <div style="padding:0 20px">
            <p style="font-weight: bold;text-align: center;font-size: 16px">{{data_sys_modal.msg_title}}</p>
            <p style="text-align: right;margin: 10px 2px 0px auto;">消息接收日期：{{data_sys_modal.syscreatedate}}</p><br/>
            <hr>
            <p style="min-height: 250px;margin-top: 20px">{{data_sys_modal.content}}<a @click="goTodo"
                                                                                       v-if="data_sys_modal.url != null">前往办理</a>
            </p>
          </div>
        </a-spin>
        <template slot="footer">
          <a-button key="forward" type="primary" @click="handleCancel">{{'关闭'}}
          </a-button>
        </template>
      </a-modal>
    </div>
  </transition>
</template>

<script>
  import {mapGetters} from 'vuex'
  import Vue from 'vue'
  import {pbService} from '../../api/manage.js'
  
  import {menuLoad} from '../../api/manage.js'
  import {loginRedirect} from '../../api/login'
  import moment from 'moment'
  import 'moment/locale/zh-cn';

  export default {
    name: 'GlobalHeader',
    data() {
      return {
        data:[],
        loading: true,
        loadingMore: false,
        showLoadingMore: true,
        page:0,
        sysCount: 0    //系统消息未读数量
        , totalCount: 0  //未读总数量
        , privateCount: 0//私信消息未读数量
        , noticeLoadding: false,
        // noticeVisible: false,
        keyWord: '',
        visible: false,
        data_sys_modal: [],
        visible_modal: false,
        confirmLoading: false,
        visible_pwd: false,
        form_pwd: this.$form.createForm(this),
        form: this.$form.createForm(this),
        account_uuid: '',
        passwordDesc: '',
        websocket: null,
        serverTimeoutObj: null,
        pagination: {
          current: 1,
          pageSize: 4
        },
      }
    },

    props: {
      theme: {
        type: String,
        required: false,
        default: 'dark'
      },
      collapsed: {
        type: Boolean,
        required: false,
        default: false
      }
    },

    computed: {
      ...mapGetters(['userName', 'avatar', 'departs', 'userInfo', 'userId', 'apps', 'menus','tabs']),
    },
    created() {
      this.loadData();
    },
    destroyed: function () {
      //页面销毁时关闭长连接
      this.websocket.close();
      clearInterval(this.serverTimeoutObj);
    },
    mounted() {
      if (this.userInfo.personuuid.trim() != '') {
        this.queryMsginfo();
      }
    },
    watch: {
      // totalCount(v){
      //   alert(v)
      // }
    },
    methods: {
      help(){
        let obj = {
          menuname: '系统帮助',
          menuurl: '/sysHelp/list'
        }
        this.$multiTab.open(obj.menuurl, obj.menuname, true);
      },
      loadData() {
        if (this.userInfo.personuuid.trim() != '') {
          this.unReadCount()
          this.initWebSocket()
        }
        this.initPasswordPolicy();
      },
      initPasswordPolicy() {
        //当前登录账户密码是否符合密码策略
        if (!this.userInfo.matchPasswordPolicy && Vue.ss.get('matchPasswordPolicy') === null) {

          this.visible_pwd = true;
          pbService(
            'service.uc.passwordService',
            'queryPasswordPolicy',
            {
              "manage_unit_uuid": this.userInfo.manageunituuid,
            }
          ).then(d => {
            this.passwordDesc = d.passwordDesc
          }).catch(err => {
            this.$message.info(err);
          })

        }
      },
      goWeb(){
        // TODO 演示需要，暂时先写死一个地址，后期做成配置项
        //loginRedirect("http://117.149.2.233:8194");
        //loginRedirect("http://localhost:8001");
        pbService(
          'service.core.parameterService',
          'queryParamListByCond',
          {
            "param_info":{
              app_code:"EGW",
              para_code:"website_url"
            },
            "result_fields":"para_value"
          }
        ).then( res => {
          if (res && res.resultset && res.resultset[0].para_value){
            loginRedirect(res.resultset[0].para_value);
          } else {
            this.$message.info("请配置正确的门户网站地址！");
          }
        })
      },
      //初始话websocket实例
      initWebSocket() {
        let _this = this;
        // ws地址 -->这里是你的请求路径
        const wsuri = `ws://${window.location.host}/ws/msgWebsocket/` + this.userInfo.personuuid;
        if ('WebSocket' in window) {
          this.websocket = new WebSocket(wsuri);
          console.log(`GlobalHeader WebSocket readyState:${this.websocket.readyState}`)
          // 连接成功
          this.websocket.onopen = function () {
            console.log("GlobalHeader WebSocket连接成功");
            heartCheck.reset().start();
          };
          // 连接错误
          this.websocket.onerror = function (event) {
            console.error("GlobalHeader WebSocket连接发生错误",event);
          };
          // 收到消息的回调，e.data为收到的信息
          this.websocket.onmessage = function (e) {
            heartCheck.reset().start();
            const redata = JSON.parse(e.data);
            if (redata.ping == 'pong') {
              console.log("通讯正常")
            } else {
              setTimeout(() => {
                _this.unReadCount();
                _this.queryMsginfo(_this.page);
              }, 200);
              if (redata.status === "0") {
                _this.openNotification(redata);
              }
            }

          };

          //连接关闭的回调方法
          this.websocket.onclose = function () {
            _this.websocket.close();
            console.log("GlobalHeader WebSocket连接关闭");
          };
          //监听窗口关闭事件，当窗口关闭时，主动去关闭websocket连接，防止连接还没断开就关闭窗口，server端会抛异常。
          window.onbeforeunload = function () {
            _this.websocket.close();
          }
          // 心跳检测, 每隔一段时间检测连接状态，如果处于连接中，就向server端主动发送消息，来重置server端与客户端的最大连接时间，如果已经断开了，发起重连。
          let heartCheck = {
            // 9分钟发一次心跳，比server端设置的连接时间稍微小一点，在接近断开的情况下以通信的方式去重置连接时间。
            reset: function () {
              console.log("重置循环");
              clearInterval(_this.serverTimeoutObj);
              return this;
            },
            start: function () {
              var self = this;
              console.log("开始");
              _this.serverTimeoutObj = setInterval(function () {
                if (_this.websocket.readyState == 1) {
                  console.log("连接状态，发送消息保持连接");
                  let ping = {
                    "ping": "pong"
                  }
                  _this.websocket.send(JSON.stringify(ping));
                  heartCheck.reset().start();    // 如果获取到消息，说明连接是正常的，重置心跳检测
                } else {
                  _this.websocket.close();
                  console.log("断开状态，尝试重连");
                  _this.initWebSocket();
                }
              }, 550000)
            }
          }
        } else {
          alert('当前浏览器不支持websocket')

        }
      },
      openNotification(val) {
        const key = `open${Date.now()}`;
        this.$notification.open({
          message: val.msg_title,
          description: val.content,
          placement: "bottomRight",
          duration: 4.5,//4.5s自动关闭
          style: "cursor:pointer",
          onClick: () => {
            this.$notification.close(key)
            this.viewMsg(val.msg_uuid);
          },
          key,
        });
      },
      goTodo() {
        this.visible_modal = false;
        let obj = {
          menuname: '业务办理页',
          menuurl: this.data_sys_modal.url
        }
        this.$multiTab.open(obj.menuurl, obj.menuname, true);
      },
      //查看系统消息
      viewMsg(msg_uuid) {
        this.visible_modal = true;
        this.confirmLoading = true;
        pbService(
          'service.msg.sysMsgService',
          'queryMsgById',
          {
            "msg_uuid": msg_uuid,
            "result_fields": ""
          }
        ).then(d => {
          this.data_sys_modal = d.result;
          //未读情况下改变状态
          if (d.result.is_readed === '0') {
            this.setReaded(d.result.msg_uuid);
          }
          this.confirmLoading = false;
        }).catch(err => {
          this.$message.info(err);
        })
      },
      setReaded(msg_uuid) {
        pbService(
          'service.msg.sysMsgService',
          'setReaded',
          {
            "user_info": this.userInfo,
            "msg_uuid": msg_uuid,
          }
        ).then(d => {
          this.queryMsginfo(this.page);
          this.unReadCount();
        }).catch(err => {
          this.$message.info(err);
        })
      },
      toSys() {
        let obj = {
          menuname: '系统消息',
          menuurl: '/sysMsg/list'
        }
        this.$multiTab.open(obj.menuurl, obj.menuname, true);
      },
      toggle() {
        this.$emit('toggle')
      },

        // 切换部门重新加载菜单
        changeDepart({key}) {
            /*key && this.$store.dispatch('SwitchDepart', key).then(()=>{
              this.$store.dispatch('GetUserInfo').then()
            })*/
            let _this = this
            if (key && this.userInfo.account_id !== key) {
                pbService(
                    'service.oauth.defaultAuthorzationService',
                    'switchUsers',
                    {
                        "account_uuid": key,
                        "params":{}
                    }).then(res => {
                    let token = res.access_token
                    if (res.access_token) {
                        Vue.ss.set('token', res.access_token, res.expires_in * 1000)
                        Vue.ss.set('refresh_token', res.refresh_token, 3600 * 24 * 1000)
                        Vue.ss.get('tabs').map(o=>{
                            if (o.path !== '/dashboard/home') {
                                _this.$store.dispatch('CloseTab', o.path)
                            }
                        })
                        this.$router.push('/dashboard/home')
                        location.reload();

                    }
                });
            }
        },

      // 去自定义首页
      goUserDesgin() {
        this.$multiTab.open("/dashboard/design?isUser=true", "自定义首页");
      },
      goShowDesgin() {
        this.$multiTab.open("/demo", "自定义首页展示");
      },
      /**
       * Restore default module
       */
      restoreDefault(){
        //1.If the current tab contains a custom home page, the tab will be removed
        const tab = this.tabs.find(o => o.path === '/dashboard/design?isUser=true');
        if(tab){
          this.$multiTab.close(tab.path);
        }
        this.$store.dispatch('HomeFetch',true).then(data => {
          this.$store.dispatch('HomeFetch',false)
        })
        //2.call background service to delete personal module
        pbService(
          'service.pf.componentAccountService',
          'delTempByAccount',
          {
            "op_acc": this.userInfo.account_id
          }
        ).then(d => {
          //3.back to the front page
          this.$router.push('/login')
        })

      },
      // 注销
      logout() {
        this.$store.dispatch('Logout').then(() => {
          this.$router.push('/login')
        })
      },
      unReadCount() {
        pbService(
          'service.msg.sysMsgService',
          'unReadCount',
          {
            "person_uuid": this.userInfo.personuuid
          }
        ).then(d => {
          this.$nextTick(() => {
            this.totalCount = d.result.totalCount;
            this.privateCount = d.result.privateCount;
            this.sysCount = d.result.sysCount;
          })
        }).catch(err => {
          this.$message.error(err);
        })
      },
      menuLoad(appuuid) {
        menuLoad(appuuid, this.userInfo.account_id, this.userInfo.deptuuid, this.userInfo.manageunituuid).then(o => {
          this.$store.commit('SET_MENUS', o);
        })
      },
      onSearch() {
        let obj = {
          menuname: '搜索',
          menuurl: '/esSearch/list?keyWord=' + this.keyWord
        }
        this.$multiTab.open(obj.menuurl, obj.menuname, true);
      },
      //弹出修改基本信息窗口
      modInfor() {
        let obj = {
          menuname: '个人信息设置',
          menuurl: '/staffInfoEdit/list'
        }
        this.$multiTab.open(obj.menuurl, obj.menuname, true);
      },
      wfDepute(){
        let obj = {
          menuname: '流程委托设置',
          menuurl: '/wf/depute'
        }
        this.$multiTab.open(obj.menuurl, obj.menuname, true);
      },
      handleCancel() {
        this.visible = false;
        this.visible_modal = false;
        this.visible_pwd = false;
        this.form_pwd.resetFields()
        this.form.resetFields()
      },
      //修改个人信息
      handleOk() {
        const {form: {validateFields}} = this;
        this.confirmLoading = true;
        validateFields((errors, values) => {
          if (!errors) {
            values.birth_date = values.birth_date.format('YYYY-MM-DD');
            values.person_uuid = this.userInfo.personuuid;
            pbService(
              'service.uc.staffService',
              'change',
              {
                "op_account_uuid": this.userId,
                "staff_info": values
              }
            ).then(() => {
              this.$message.success('人员信息更新成功')
            }).catch(err => {
              this.$message.error(err);
            }).finally(() => {
              this.confirmLoading = false;
              this.visible = false;
              this.form.resetFields()
            })
          } else {
            this.confirmLoading = false
          }
        })
      },
      changePwd() {
        this.visible_pwd = true;
      },
      //修改密码
      handleok_pwd() {
        const {form_pwd: {validateFields}} = this;
        this.confirmLoading = true;
        validateFields((errors, values) => {
          if (!errors) {
            values.manage_unit_uuid = this.userInfo.manageunituuid;
            pbService(
              'service.uc.accountService',
              'changePwd',
              {
                "op_acc": this.userId,
                "account_info": values
              }
            ).then(() => {
              this.$message.success('密码修改成功')

              Vue.ss.set("matchPasswordPolicy", "true");

              this.visible_pwd = false;
              this.form_pwd.resetFields()
            }).catch(err => {
              this.$message.error(err.desc);
            }).finally(() => {
              this.confirmLoading = false;
            })
          } else {
            this.confirmLoading = false
          }
        })
      },
      queryMsginfo(page) {
        if(page){
          this.page = page
        }else{
          this.page = this.page + this.pagination.pageSize;
        }
        //如果小于4条数据就把数据量初始化
        if(this.data.length < this.pagination.pageSize){
          this.page = this.pagination.pageSize;
        }
        pbService(
          'service.msg.sysMsgService',
          'pageQureySysMsgList',
          {
            "person_uuid": this.userInfo.personuuid?this.userInfo.personuuid:'system',
            "msg_info": {
              "is_readed":'0'
            },
            "result_fields":  "",
            "order_field":  "syscreatedate desc"
          },
        {page: this.pagination.current, rows: this.page}
        ).then(d => {
          this.data = d.resultset
          // if(d.total && d.total > this.data.length){
          //   this.showLoadingMore = true //加载更多按钮
          // }else{
          //   this.showLoadingMore = false
          // }
          if(this.data.length>0){
            this.showLoadingMore = true //加载更多按钮
          }else{
            this.showLoadingMore = false
          }
          this.loading = false; //初始化加载状态
          this.loadingMore = false; //点击加载更多的加载状态
        }).catch(err => {
          this.loading = false;
          this.loadingMore = false;
          this.$message.error(err);
        })
      },
      onLoadMore(){
        this.loadingMore = true;
        this.queryMsginfo();
      },
      setAllReaded() {
        pbService(
          'service.msg.sysMsgService',
          'setAllReaded',
          {
            "op_acc": this.userInfo.account_id,
            "person_uuid": this.userInfo.personuuid,
            "msg_type": "0"
          }
        ).then(() => {
          this.queryMsginfo()
        }).catch(err => {
          this.$message.error(err);
        })
      }
    }
  }
</script>

<style lang="less">
  @import '../index.less';

  .header {
    .ant-input {
      font-size: 12px;
    }

    .ant-input:focus {
      box-shadow: 0px 2px 8px 0px rgba(214, 234, 231, 1);
    }

    .ant-input-affix-wrapper .ant-input:not(:first-child) {
      padding-left: 36px
    }
  }

  .title {
    margin-right: 18px;
    //color: #64C2BC;
    color: #109272;
    font-weight: bold;
  }

  .search-input {
    margin-top: 17px;
    width: 188px !important;
    height: 32px;
    border: none;
    outline: none;
    border-radius: 16px;
    background-color: #F3F8F6;
    // padding: 10px 14px !important;
    margin-right: 24px !important;

    .ant-input {
      border: none;
      background: rgba(243, 248, 246, 1);
      border-radius: 16px;
    }
  }

  .avatar-bg {
      position: absolute;
      width: 36px;
      height: 36px;
      border-radius: 25%;
      background-color: #109272;
      top: 14px;
      right: 6px;
  }

  .avatar-content {
    position: relative;
    color: white;
  }

  .header-animat {
    position: relative;
    z-index: @ant-global-header-zindex;
  }

  .showHeader-enter-active {
    transition: all 0.25s ease;
  }

  .showHeader-leave-active {
    transition: all 0.5s ease;
  }

  .showHeader-enter, .showHeader-leave-to {
    opacity: 0;
  }

  // .ant-badge-multiple-words{
  // padding: 0 !important;
  // }
  // .ant-badge-count, .ant-badge-dot, .ant-badge .ant-scroll-number-custom-component{
  //   right:2px !important;
  // }
  .notice-badge {
    position: absolute !important;
    left: 30px;
    top: 14px;

    .ant-badge-count {
      min-width: 15px;
      height: 15px;
      line-height: 15px;
      padding: 0;
      font-size: 11px;
    }
  }
  .btn{
    width:96px;
    height:30px;
    background:rgba(100,194,188,0);
    border:1px solid rgba(125, 136, 138, 0.6);
    border-radius:15px;
    font-size: 12px;
  }
</style>
<style scoped>
  .demo-loadmore-list {
    min-height: 150px;
    width:320px;
    max-height:480px;
    /*overflow-y: scroll;*/
    /*overflow-x: hidden;*/
  }
  /*进度条样式*/
  div::-webkit-scrollbar{
    width:5px;
    height:10px;
    /**/
  }
  div::-webkit-scrollbar-track{
    background: rgb(239, 239, 239);
  //background: #ffffff;
    border-radius:2px;
  }
  div::-webkit-scrollbar-thumb{
    background: #bfbfbf;
  //background: #ffffff;
    border-radius:10px;
  }
  div::-webkit-scrollbar-thumb:hover{
    background: #333;
  }
  div::-webkit-scrollbar-corner{
    background: #179a16;
  }
  .ant-list-item-meta-title{
    font-size: 12px;
  }

  .layout.ant-layout .header{
      height:64px;
      padding:0 12px 0 0;
      background:url('../../assets/login/head.png') 0 0 no-repeat;
      background-size:100% 68px;
      box-shadow:0 1px 4px rgba(0,21,41,.08);
      position:relative;
      vertical-align:middle;
  }
</style>
